module.exports = __webpack_public_path__ + "img/bar-3.a347ccf6.png";